
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PractitionersHeader from "@/components/practitioners/PractitionersHeader";
import PractitionersContent from "@/components/practitioners/PractitionersContent";
import PractitionersLoading from "@/components/practitioners/PractitionersLoading";
import { usePractitionersLocation } from "@/hooks/usePractitionersLocation";
import { usePractitionersFilters } from "@/hooks/usePractitionersFilters";
import { Practitioner } from "@/types/practitioner";

// Export types for backward compatibility
export type { Practitioner, PractitionerService } from "@/types/practitioner";

export default function Practitioners() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(true);
  const [isPageLoading, setIsPageLoading] = useState(true);
  
  
  const {
    userLocation,
    userAddress,
    locationError,
    isGettingLocation,
    isLoadingAddress,
    city,
    state,
    country,
    timezoneDisplay,
    isApproximateLocation,
    requestLocationAccess,
    setManualLocation,
    isGeolocationPolicyBlocked
  } = usePractitionersLocation();

  const {
    filters,
    setFilters,
    sortBy,
    setSortBy,
    searchQuery,
    setSearchQuery,
    debouncedSearchQuery,
    timeSlots,
    handleCategoryChange,
    isDateDisabled
  } = usePractitionersFilters();

  // Check booking choice on mount
  useEffect(() => {
    const choiceMade = sessionStorage.getItem('booking_choice_made');
    if (!choiceMade) {
      navigate('/booking-choice');
    }
  }, [navigate]);

  // Initial location request
  useEffect(() => {
    const timer = setTimeout(() => {
      if (navigator.geolocation) {
        requestLocationAccess();
      }
      setIsPageLoading(false);
    }, 200);

    return () => clearTimeout(timer);
  }, [requestLocationAccess]);

  // Show initial loading state
  if (isPageLoading) {
    return <PractitionersLoading />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-16">
        <div className="bg-gradient-to-br from-amber-50 to-orange-50 min-h-full">
          <div className="container mx-auto px-4 py-8">
            <PractitionersHeader />
            
            <PractitionersContent
              showSidebar={showSidebar}
              setShowSidebar={setShowSidebar}
              filters={filters}
              setFilters={setFilters}
              sortBy={sortBy}
              setSortBy={setSortBy}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              debouncedSearchQuery={debouncedSearchQuery}
              userLocation={userLocation}
              userAddress={userAddress}
              locationError={locationError}
              isGettingLocation={isGettingLocation}
              isLoadingAddress={isLoadingAddress}
              requestLocationAccess={requestLocationAccess}
              timeSlots={timeSlots}
              isDateDisabled={isDateDisabled}
              handleCategoryChange={handleCategoryChange}
              city={city}
              state={state}
              country={country}
              timezoneDisplay={timezoneDisplay}
              isApproximateLocation={isApproximateLocation}
            />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
